import React from 'react';
import Terminal from '../components/Terminal';
import { developerInfo } from '../mock';
import { Github, Linkedin, Mail } from 'lucide-react';

const Home = () => {
  return (
    <div className="page-container home-page">
      <div className="hero-section">
        <div className="hero-content">
          <div className="glitch-wrapper">
            <h1 className="hero-title glitch" data-text="GABRIELE TITA">
              GABRIELE TITA
            </h1>
          </div>
          <p className="hero-subtitle">{developerInfo.role}</p>
          <p className="hero-location">
            <span className="text-cyan">&gt;</span> {developerInfo.location}
          </p>
          
          <div className="hero-links">
            <a href={`mailto:${developerInfo.email}`} className="hero-link" target="_blank" rel="noopener noreferrer">
              <Mail size={20} />
              <span>EMAIL</span>
            </a>
            <a href={developerInfo.github} className="hero-link" target="_blank" rel="noopener noreferrer">
              <Github size={20} />
              <span>GITHUB</span>
            </a>
            <a href={developerInfo.linkedin} className="hero-link" target="_blank" rel="noopener noreferrer">
              <Linkedin size={20} />
              <span>LINKEDIN</span>
            </a>
          </div>

          <div className="terminal-hint">
            <span className="blink">▶</span> Try the interactive terminal below or use the navigation menu
          </div>
        </div>
      </div>

      <div className="terminal-section">
        <h2 className="section-title">
          <span className="text-amber">&lt;</span>
          INTERACTIVE_TERMINAL
          <span className="text-amber">/&gt;</span>
        </h2>
        <Terminal fullScreen={true} />
      </div>

      <div className="ascii-divider">
        {'='.repeat(80)}
      </div>

      <div className="quick-info">
        <div className="info-box">
          <h3 className="info-title">$ cat specialization.txt</h3>
          <div className="info-content">
            <p className="text-green">&gt; Backend Development</p>
            <p className="text-green">&gt; Web Application Vulnerability Assessment</p>
            <p className="text-green">&gt; API Design & Architecture</p>
            <p className="text-green">&gt; Container Security</p>
          </div>
        </div>

        <div className="info-box">
          <h3 className="info-title">$ echo $INTERESTS</h3>
          <div className="info-content">
            <p className="text-purple">Building secure, scalable backend systems</p>
            <p className="text-purple">Exploring offensive security techniques</p>
            <p className="text-purple">Contributing to open-source security tools</p>
            <p className="text-purple">Sharing knowledge through technical writing</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;